
import { Vue, Component, Prop } from "vue-property-decorator";
import SectionHeader from "./components/SectionHeader.vue";
import InfoField from "./components/InfoField.vue";
import InfoSection from "./components/InfoSection.vue";

@Component({
  components: {
    SectionHeader,
    InfoField,
    InfoSection,
  },
})
export default class FunctionalAssessment extends Vue {
  @Prop({ type: Object, required: true }) readonly data!: any;
  @Prop({ type: Object, required: true }) readonly proejctData!: any;
  @Prop({ type: Object, required: true }) readonly currentUser!: object;


}
